// extracted by mini-css-extract-plugin
export default {"paper":"DialogPopup_paper__17-7M","paper_big":"DialogPopup_paper_big__P5tnN","popup_header":"DialogPopup_popup_header__epE+i","popup_content":"DialogPopup_popup_content__-xqz7"};